export default __webpack_public_path__ + "static/media/R8.168f28f6.png";